/**
 * Simulated IWOS Weather Messages
 * 6 test messages with varying data combinations for testing Phase 1 implementation
 */

export const SIMULATED_IWOS_MESSAGES = [
  {
    id: 'msg1',
    name: 'Message 1 - Lightning + Clouds + Precip',
    description: 'Active lightning (2 strikes/min), 4 cloud layers, light precipitation, pressure tendency 8 (rapid fall)',
    timestamp: '11:16:30',
    raw: `@0
N:176:0:0:0:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,11:16:30
LA:35.17981
LO:-73.31028
EL:39.0
OR:75:-1:18
TA:24.6:24.8:00
BA:1010.1:2992.2:3.5:3:8
RH:51.2:49.9
WI:10.5:210:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:012:030:100:635:000:000:2:5:7:8:0:0:300:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:02:008:0020:002:008:025:00
PA:0.01:0.01:0.20:1.20:0.00:0.00:0.01:0.20:1.20:0
PW:0:95:0:12.0:15.2:0:00
SS:96.82:3.28:7.22:178:00
~`
  },
  {
    id: 'msg2',
    name: 'Message 2 - Different Pressure Tendency',
    description: 'Pressure tendency 2 (increasing), different precip water (63), lower lightning strikes',
    timestamp: '11:16:35',
    raw: `@0
N:176:0:0:0:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,11:16:35
LA:35.17981
LO:-73.31028
EL:39.0
OR:75:-1:18
TA:24.6:24.8:00
BA:1010.1:2992.2:3.5:?:2
RH:51.2:49.9
WI:10.5:210:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:012:030:100:635:000:000:2:5:7:8:0:0:300:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:02:008:0020:002:002:002:00
PA:0.03:0.01:0.10:1.50:0.00:0.00:0.01:0.20:1.20:0
PW:0:63:0:1.0:2.0:30:00
SS:96.82:3.28:7.22:178:00
~`
  },
  {
    id: 'msg3',
    name: 'Message 3 - Tendency 6 (Decreasing)',
    description: 'Pressure tendency 6 (decreasing then steady), visibility 4km, PW code 72',
    timestamp: '11:16:40',
    raw: `@0
N:176:0:0:0:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,11:16:40
LA:35.17981
LO:-73.31028
EL:39.0
OR:75:-1:18
TA:24.6:24.8:00
BA:1010.1:2992.2:3.5:?:6
RH:51.2:49.9
WI:10.5:210:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:012:030:100:635:000:000:2:5:7:8:0:0:300:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:02:008:0020:002:002:002:00
PA:0.03:0.01:0.10:1.50:0.00:0.00:0.01:0.20:1.20:0
PW:0:72:0:4.0:4.5:10:00
SS:96.82:3.28:7.22:178:00
~`
  },
  {
    id: 'msg4',
    name: 'Message 4 - Zero Precipitation',
    description: 'No precipitation (all zeros), pressure tendency 2, PW code 52, visibility 6km',
    timestamp: '11:16:45',
    raw: `@0
N:176:0:0:0:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,11:16:45
LA:35.17981
LO:-73.31028
EL:39.0
OR:75:-1:18
TA:24.6:24.8:00
BA:1010.1:2992.2:3.5:?:2
RH:51.2:49.9
WI:10.5:210:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:012:030:100:635:000:000:2:5:7:8:0:0:300:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:02:008:0020:002:002:002:00
PA:0.00:0.00:0.00:0.00:0.00:0.00:0.01:0.20:1.20:0
PW:0:52:0:6.0:8.0:04:00
SS:96.82:3.28:7.22:178:00
~`
  },
  {
    id: 'msg5',
    name: 'Message 5 - METAR (@1)',
    description: 'METAR message type, different temp (20.6C), lighter wind (8kt), clear clouds (055), no lightning',
    timestamp: '11:55:30',
    raw: `@1
N:176:0:0:0:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,11:55:30
LA:35.17981
LO:-73.31028
EL:39.0
OR:75:-1:18
TA:20.6:17.8:00
BA:1010.1:2992.2:3.5:?:0
RH:51.2:49.9
WI:8.0:180:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:055:000:000:000:000:000:2:0:0:0:0:0:?:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:0:0:0:?:?:?:00
PA:0.00:0.01:0.00:0.00:0.00:0.00:0.01:0.20:1.20:0
PW:0:65:0:3.0:4.0:0:00
SS:96.82:3.28:7.22:178:00
~`
  },
  {
    id: 'msg6',
    name: 'Message 6 - SPECI (@2) Different Location',
    description: 'SPECI message type with S flag, different location (LA:33.83, LO:-118.31), active lightning (5/10/25 strikes), 8 oktas cloud',
    timestamp: '12:28:30',
    raw: `@2
N:176:0:0:S:KQXX:1
B:48.1:60:0:e1:1:5:00
T:-25/10/07,12:28:30
LA:33.83981
LO:-118.31028
EL:39.0
OR:75:-1:18
TA:20.6:17.8:00
BA:1010.1:2992.2:3.5:?:5
RH:51.2:49.9
WI:8.0:180:12.0:200:12.0:200:FF:00
GU:24.0:200:24.0:200:12.0:0:?:?
CL:1aa10:055:000:000:000:000:000:8:0:0:0:0:0:?:0:00
IR:0:0:0:300534060613880:TA19002:EMSS:00
LT:5:10:25:5.2:12.0:50.1:00
PA:0.00:0.01:0.00:0.00:0.00:0.00:0.01:0.20:1.20:0
PW:0:72:0:0.1:0.2:31:00
SS:96.82:3.28:7.22:178:00
~`
  }
];

export default SIMULATED_IWOS_MESSAGES;
